import { Route, Redirect } from 'react-router-dom'
import { useJWT } from 'state/hooks'

const protectedRouteHoc = ({ component: Component, ...rest }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const jwt = useJWT()
    console.log(jwt, "=====")
    if (!jwt) {
        // TODO: save rest.location
        return <Redirect to="/login" />
    }

    return <Route {...rest} render={props => <Component {...props} />} />
}

export const ProtectedRoute = protectedRouteHoc
